/**
 * Reads the CMAS feature flag directly from the environment rather than from
 * `staticConfig`, because the partner config files consume it and
 * `config.ts -> EnvConfigHelper -> configs/.../partners/*` would be a cycle.
 */
export const isCmasEnabled = (): boolean => process.env.REACT_APP_CMAS_ENABLED === 'true';

/**
 * Version recorded against the amazon-prime Terms and Conditions / Privacy
 * Policy consents. Must match the version the consent store issues, otherwise
 * the prime-consent rule sends an already-consented user back to the form.
 */
export const getPrimeConsentVersion = (): string => (isCmasEnabled() ? '2.0' : '1.0');
